<div class="px-4 sm:px-8 py-6 max-w-4xl mx-auto">

  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 text-center flex items-center justify-center" style="margin-bottom: 8px;">
    <mat-icon style="color: #1C593D; margin-right: 8px; flex-shrink: 0;">account_balance</mat-icon>
    Medio de Pago
  </h1>
  <p style="text-align: center; font-size: 0.85rem; color: #6b7280; margin: 0 0 24px;">
    {{ modoVes ? 'Transferencia bancaria Venezuela' : 'Transferencia electr&oacute;nica' }}
  </p>

  <!-- Instrucción -->
  <p *ngIf="!modoVes || dataVes.length > 0" style="text-align: center; font-size: 0.9rem; color: #374151; margin: 0 0 20px;">
    Realizar el dep&oacute;sito a una de las siguientes cuentas:
  </p>

  <!-- ══════════ Cards CLP (usuarios NO venezolanos) ══════════ -->
  <div *ngIf="!modoVes" class="flex flex-wrap justify-center gap-5" style="margin-bottom: 28px;">
    <ng-container *ngFor="let item of data">
      <div *ngIf="item.disponible===true"
        style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; width: 350px; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">

        <!-- Header card banco -->
        <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 20px; border-bottom: 2px solid #bbf7d0; display: flex; align-items: center; gap: 10px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D; flex-shrink: 0;">account_balance</mat-icon>
          <span style="font-weight: 700; font-size: 0.92rem; color: #1e5a3f;">{{ item.banco }}</span>
        </div>

        <!-- Datos de la cuenta -->
        <div style="padding: 16px 20px; display: flex; flex-direction: column; gap: 10px;">
          <div>
            <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de cuenta</span>
            <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">Cuenta {{ item.tipoCuenta }}</p>
          </div>
          <div>
            <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Titular</span>
            <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ item.cuenta }}</p>
          </div>
          <div>
            <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">N&uacute;mero de cuenta</span>
            <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 700; color: #2563eb; font-family: monospace;">{{ item.numeroCuenta }}</p>
          </div>
          <div>
            <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">RUT</span>
            <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ formatRut(item.rutemisor) }}</p>
          </div>
        </div>

        <!-- Botón copiar -->
        <div style="padding: 0 20px 16px;">
          <button type="button" (click)="copyData(item)"
            style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 16px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">content_copy</mat-icon>
            Copiar datos
          </button>
        </div>

      </div>
    </ng-container>
  </div>

  <!-- ══════════ Sin cuentas VES ══════════ -->
  <div *ngIf="modoVes && dataVes.length === 0"
    style="max-width: 640px; margin: 0 auto 24px; background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">
    <div style="background: linear-gradient(135deg, #fef3c7, #fef9c3); padding: 16px 24px; border-bottom: 2px solid #fde68a; display: flex; align-items: center; gap: 10px;">
      <mat-icon style="font-size: 28px; width: 28px; height: 28px; color: #f59e0b; flex-shrink: 0;">info</mat-icon>
      <h3 style="font-weight: 700; font-size: 1rem; color: #92400e; margin: 0;">Servicio no disponible</h3>
    </div>
    <div style="padding: 24px; text-align: center;">
      <mat-icon style="font-size: 56px; width: 56px; height: 56px; color: #d1d5db; margin-bottom: 12px;">account_balance_wallet</mat-icon>
      <p style="font-size: 0.9rem; color: #374151; margin: 0 0 8px; line-height: 1.5; font-weight: 600;">
        No hay cuentas bancarias disponibles en este momento.
      </p>
      <p style="font-size: 0.82rem; color: #6b7280; margin: 0 0 20px; line-height: 1.5;">
        Por favor, int&eacute;ntalo m&aacute;s tarde o contacta a soporte para m&aacute;s informaci&oacute;n.
      </p>
      <button type="button" (click)="goToHome()"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">home</mat-icon>
        Volver al inicio
      </button>
    </div>
  </div>

  <!-- ══════════ Cards VES (usuarios venezolanos) ══════════ -->
  <div *ngIf="modoVes && dataVes.length > 0" class="flex flex-wrap justify-center gap-5" style="margin-bottom: 28px;">
    <div *ngFor="let item of dataVes"
      style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; width: 350px; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">

      <!-- Header card banco VES -->
      <div style="background: linear-gradient(135deg, #fff7ed, #ffedd5); padding: 14px 20px; border-bottom: 2px solid #fed7aa; display: flex; align-items: center; gap: 10px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #ea580c; flex-shrink: 0;">account_balance</mat-icon>
        <span style="font-weight: 700; font-size: 0.92rem; color: #9a3412;">{{ item.banco }}</span>
      </div>

      <!-- Datos de la cuenta VES -->
      <div style="padding: 16px 20px; display: flex; flex-direction: column; gap: 10px;">
        <div>
          <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Tipo de cuenta</span>
          <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">Cuenta {{ item.tipoCuenta }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">Titular</span>
          <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ item.titular }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">N&uacute;mero de cuenta</span>
          <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 700; color: #ea580c; font-family: monospace;">{{ item.numeroCuenta }}</p>
        </div>
        <div>
          <span style="font-size: 0.7rem; font-weight: 600; color: #6b7280; text-transform: uppercase;">RIF / C&eacute;dula</span>
          <p style="margin: 2px 0 0; font-size: 0.88rem; font-weight: 600; color: #111827;">{{ item.cedula }}</p>
        </div>
      </div>

      <!-- Botón copiar VES -->
      <div style="padding: 0 20px 16px;">
        <button type="button" (click)="copyDataVes(item)"
          style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 16px; background: #ea580c; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#c2410c'" onmouseout="this.style.background='#ea580c'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">content_copy</mat-icon>
          Copiar datos
        </button>
      </div>

    </div>
  </div>

  <!-- Pasos finales (NO VE) -->
  <div *ngIf="!modoVes" style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06); max-width: 640px; margin: 0 auto 24px;">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <div class="flex flex-col sm:flex-row items-center gap-3">
        <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #1C593D; flex-shrink: 0;">schedule</mat-icon>
        <div style="text-align: center;" class="sm:text-left">
          <div style="display: flex; align-items: center; gap: 6px; justify-content: center;" class="sm:justify-start">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #16a34a; flex-shrink: 0;">check_circle</mat-icon>
            <h3 style="font-weight: 700; font-size: 1rem; color: #1e5a3f; margin: 0;">Pasos finales: &iquest;Ya hiciste la transferencia?</h3>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 20px 24px; text-align: center;">
      <p style="font-size: 0.88rem; color: #374151; margin: 0 0 16px; line-height: 1.5;">
        Una vez realizada la transferencia por favor regresar al <strong>Inicio</strong>.
        Tu saldo en <strong>CLP</strong> se actualizar&aacute; autom&aacute;ticamente en un lapso m&aacute;ximo de 10 minutos.
      </p>
      <button type="button" (click)="goToHome()"
        style="display: inline-flex; align-items: center; gap: 8px; padding: 12px 28px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
        onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">home</mat-icon>
        VOLVER AL INICIO Y VER MI SALDO
      </button>
    </div>
  </div>

  <!-- Pasos finales + Referencia (VE) -->
  <div *ngIf="modoVes && dataVes.length > 0" style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06); max-width: 640px; margin: 0 auto 24px;">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <div class="flex flex-col sm:flex-row items-center gap-3">
        <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #1C593D; flex-shrink: 0;">receipt</mat-icon>
        <div style="text-align: center;" class="sm:text-left">
          <div style="display: flex; align-items: center; gap: 6px; justify-content: center;" class="sm:justify-start">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #16a34a; flex-shrink: 0;">check_circle</mat-icon>
            <h3 style="font-weight: 700; font-size: 1rem; color: #1e5a3f; margin: 0;">&iquest;Ya hiciste la transferencia?</h3>
          </div>
        </div>
      </div>
    </div>
    <div style="padding: 20px 24px;">
      <p style="font-size: 0.85rem; color: #374151; margin: 0 0 16px; line-height: 1.5; text-align: center;">
        Ingresa la referencia y el monto de tu transferencia para agilizar la verificaci&oacute;n.
      </p>

      <!-- Formulario referencia -->
      <div style="display: flex; flex-direction: column; gap: 12px; margin-bottom: 16px;">
        <!-- Selector de cuenta destino -->
        <div *ngIf="dataVes.length > 1">
          <label style="display: block; font-size: 0.78rem; font-weight: 600; color: #1e5a3f; margin-bottom: 4px;">Cuenta destino</label>
          <select
            [(ngModel)]="cuentaVesSeleccionada"
            style="width: 100%; padding: 10px 14px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.88rem; font-weight: 600; color: #374151; background: white; outline: none; box-sizing: border-box; transition: border-color 0.2s; cursor: pointer; -webkit-appearance: none; -moz-appearance: none; appearance: none; background-image: url('data:image/svg+xml;utf8,<svg fill=&quot;%236b7280&quot; viewBox=&quot;0 0 24 24&quot; xmlns=&quot;http://www.w3.org/2000/svg&quot;><path d=&quot;M7 10l5 5 5-5z&quot;/></svg>'); background-repeat: no-repeat; background-position: right 12px center; background-size: 18px;"
            onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
            <option [ngValue]="null" disabled>Selecciona la cuenta a la que transferiste</option>
            <option *ngFor="let cuenta of dataVes" [ngValue]="cuenta">
              {{ cuenta.banco }} - {{ cuenta.numeroCuenta }}
            </option>
          </select>
        </div>
        <div>
          <label style="display: block; font-size: 0.78rem; font-weight: 600; color: #1e5a3f; margin-bottom: 4px;">N&uacute;mero de referencia</label>
          <input type="text"
            [(ngModel)]="referenciaVes"
            placeholder="Ej: 1234567890"
            style="width: 100%; padding: 10px 14px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.88rem; font-weight: 600; color: #374151; background: white; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
            onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
        </div>
        <div>
          <label style="display: block; font-size: 0.78rem; font-weight: 600; color: #1e5a3f; margin-bottom: 4px;">Monto transferido (VES)</label>
          <input type="text"
            [(ngModel)]="montoVes"
            placeholder="Ej: 50000"
            style="width: 100%; padding: 10px 14px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.88rem; font-weight: 600; color: #374151; background: white; outline: none; box-sizing: border-box; transition: border-color 0.2s;"
            onfocus="this.style.borderColor='#34d399'" onblur="this.style.borderColor='#e5e7eb'">
        </div>
      </div>

      <!-- Resumen datos bancarios -->
      <div *ngIf="cuentaVesSeleccionada"
        style="background: #f9fafb; border: 1px solid #e5e7eb; border-radius: 10px; padding: 10px 14px; margin-bottom: 16px;">
        <div style="font-size: 0.72rem; font-weight: 600; color: #6b7280; text-transform: uppercase; margin-bottom: 6px;">Datos de la cuenta destino</div>
        <div style="display: flex; flex-wrap: wrap; gap: 4px 16px; font-size: 0.78rem; color: #374151;">
          <span><strong>Banco:</strong> {{ cuentaVesSeleccionada.banco }}</span>
          <span><strong>Cuenta:</strong> {{ cuentaVesSeleccionada.tipoCuenta }}</span>
          <span><strong>Titular:</strong> {{ cuentaVesSeleccionada.titular }}</span>
          <span><strong>Nro:</strong> {{ cuentaVesSeleccionada.numeroCuenta }}</span>
        </div>
      </div>

      <button type="button" (click)="enviarReferencia()"
        [disabled]="!referenciaValida || loadingReferencia || referenciaSent"
        [style.opacity]="(!referenciaValida || loadingReferencia || referenciaSent) ? '0.5' : '1'"
        [style.cursor]="(!referenciaValida || loadingReferencia || referenciaSent) ? 'not-allowed' : 'pointer'"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease; margin-bottom: 12px;"
        onmouseover="if(!this.disabled)this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white; flex-shrink: 0;">{{ loadingReferencia ? 'hourglass_top' : 'upload' }}</mat-icon>
        {{ loadingReferencia ? 'Enviando...' : 'Cargar referencia' }}
      </button>

      <button type="button" (click)="goToHome()"
        style="width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; padding: 10px; background: white; color: #1C593D; border: 2px solid #1C593D; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s;"
        onmouseover="this.style.background='#f0fdf4'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D; flex-shrink: 0;">home</mat-icon>
        Volver al inicio
      </button>
    </div>
  </div>

  <!-- Advertencia -->
  <div *ngIf="!modoVes" style="display: flex; align-items: flex-start; gap: 10px; justify-content: center; background: #fef3c7; padding: 14px 20px; border-radius: 12px; border: 1px solid #fde68a; max-width: 640px; margin: 0 auto;">
    <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #f59e0b; flex-shrink: 0; margin-top: 2px;">warning</mat-icon>
    <div>
      <p style="font-size: 0.82rem; font-weight: 600; color: #92400e; margin: 0 0 4px;">Recuerda que el pago debe estar a tu nombre, si el pago proviene de un tercero, no ser&aacute; v&aacute;lido.</p>
      <p style="font-size: 0.82rem; color: #92400e; margin: 0;">Al hacer tu recarga estar&aacute; disponible en tu wallet en un lapso m&aacute;ximo de 10 min.</p>
    </div>
  </div>

</div>
